import { connect } from "react-redux";

import React from "react";
import { Redirect, Route } from "react-router";
import Dashboard from "../pages/Dashboard";
import Calendar from "../pages/Calendar";
import Users from "../pages/Users";
import Entries from "../pages/Entries";
import ActivityLog from "../pages/ActivityLog";
import User from "../pages/Users/User";
import AddEditUser from "../pages/Users/User/AddEditUser";
import AddEditEntry from "../pages/Entries/Entry/AddEditEntryEating";
import UserCharts from "../pages/Users/User/Charts";
import Entry from "../pages/Entries/Entry";
import DateView from "../pages/Dates/Date";
import UserDataTable from "../pages/Users/User/UserDataTable";
import Login from "../pages/Auth/Login";

interface Props {
	loggedIn: any;
}

const InternalRoutes: React.FC<Props> = () => {
	return (
		<>
			<Route exact path="/">
				<Dashboard />
			</Route>
			<Route exact path="/dashboard">
				<Dashboard />
			</Route>
			<Route exact path="/login">
				<Login />
			</Route>
			<Route exact path="/users">
				<Users />
			</Route>
			<Route path="/users/add">
				<AddEditUser />
			</Route>
			<Route exact path="/users/:id">
				<User />
			</Route>
			<Route path="/users/:id/config">
				<AddEditUser />
			</Route>
			<Route path="/users/:id/charts">
				<UserCharts />
			</Route>
			<Route path="/users/:id/data">
				<UserDataTable />
			</Route>
			<Route exact path="/users/:id/entry/:eid">
				<Entry />
			</Route>
			<Route exact path="/users/:id/entry/new/:dateTS">
				<Entry />
			</Route>
			<Route exact path="/users/:id/entry/new/:dateTS/:type">
				<Entry />
			</Route>
			<Route exact path="/users/:id/date/:dateTS">
				<DateView />
			</Route>
			<Route exact path="/calendar">
				<Calendar />
			</Route>
			<Route path="/activity">
				<ActivityLog />
			</Route>
			<Route path="/entries">
				<Entries />
			</Route>
			{/* <Route exact path="/">
				<Redirect to="/login" />
			</Route> */}
		</>
	);
};

const mapStateToProps = (state: any) => ({
	loggedIn: state.user.loggedIn,
});

export default connect(mapStateToProps, {})(InternalRoutes);
